import type { ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'
import type { GifAttachment } from 'modules/community/types/post-attachment'

interface GifAttachmentPreviewProps {
  className?: string
  attachment: GifAttachment
}

export const GifAttachmentPreview = ({
  attachment,
  className,
}: GifAttachmentPreviewProps): ReactNode => (
  <div
    className={twMerge(
      'size-full overflow-hidden rounded-lg',
      !attachment.previewUrl && 'bg-bg-page',
      className,
    )}
  >
    {!!attachment.previewUrl && (
      <img
        src={attachment.previewUrl}
        alt=""
        className="size-full object-cover transition-all group-hover:scale-110"
      />
    )}
  </div>
)
